import { useContext } from "react"
import { useEffect } from "react"
import { useState } from "react"
import { api } from "../../../api/api"
import { MenuContext } from "../../../context/MenuContext"
import { Toast } from "../../../utils/Toast"
import { mascaraMoeda, maskCurrency } from "../../../utils/utils"
import { DataSheet } from "../../DataSheet"
import "../menu-form.css"


export function AdditionalModal() {
  const { categoryAdditionalId, load, additional, setAdditional } = useContext(MenuContext)

  const [state, setState] = useState({
    id: null,
    name: "",
    categoryAdditionalId: 0,
    pricing: 0,
    active: false,
  })

  useEffect(() => {
    setState((oldState) => ({
      ...oldState,
      categoryAdditionalId: categoryAdditionalId
    }))
  }, [categoryAdditionalId])

  useEffect(() => {
    if (additional && additional.id) {
      setState({
        ...additional,
        active: Boolean(additional.active)
      })
    }
  }, [additional])


  function clear() {
    const defaultAdditional = {
      id: null,
      name: "",
      categoryAdditionalId: categoryAdditionalId,
      pricing: 0,
      active: false,
    }
    setState(defaultAdditional)
    setAdditional(defaultAdditional)
  }

  async function created(e) {
    e.preventDefault()

    if (!state.name) {
      return Toast.warning('Campo nome é obrigatório.')
    }

    await api.post("/additional", state)
    Toast.success()
    await load()
    clear()
  }

  async function updated(e) {
    e.preventDefault()

    if (!state.name) {
      return Toast.warning('Campo nome é obrigatório.')
    }

    await api.put("/additional/" + state.id, state)
    Toast.success()
    clear()
    await load()
  }

  return (
    <>
      <div className="modal fade admin-form-modal menu-entity-modal" id="modalAdditional" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="additionalModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div><h5 className="modal-title" id="additionalModalLabel">{state.id ? 'Editar adicional' : 'Novo adicional'}</h5><p>Cadastre uma opção para o grupo selecionado</p></div>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => clear()}></button>
            </div>
            <div className="modal-body">
              <nav>
                <div className="nav menu-modal-tabs" id="additional-tabs" role="tablist">
                  <button className="nav-link active" id="additional-data-tab" data-bs-toggle="tab" data-bs-target="#additional-data" type="button" role="tab" aria-controls="additional-data" aria-selected="true">
                    Adicional
                  </button>
                  <button className="nav-link" id="additional-sheet-tab" data-bs-toggle="tab" data-bs-target="#additional-sheet" type="button" role="tab" aria-controls="additional-sheet" aria-selected="false">
                    Ficha
                  </button>
                </div>
              </nav>
              <div className="tab-content" id="additional-tabs-content">
                <div className="tab-pane fade show active" id="additional-data" role="tabpanel" aria-labelledby="additional-data-tab">
                  <form className="menu-modal-grid">
                    <div>
                      <label htmlFor="additional-name">Nome</label>
                      <input maxLength={40} type="text" value={state.name} onChange={(e) => setState({
                        ...state,
                        name: e.target.value
                      })} id="additional-name" />
                      <small>Nome exibido como opção no grupo.</small>
                    </div>
                    <div>
                      <label htmlFor="additional-price">Preço</label>
                      <input type="text" value={maskCurrency(state.pricing)} onChange={(e) => setState({
                        ...state,
                        pricing: mascaraMoeda(e.target.value)
                      })} id="additional-price" />
                    </div>
                    <div className="menu-modal-options menu-modal-full">
                      <label className="menu-modal-check" htmlFor="additional-active">
                      <input type="checkbox" checked={state.active} onChange={(e) => setState({
                        ...state,
                        active: Boolean(e.target.checked)
                      })} id="additional-active" /> Adicional ativo
                      </label>
                    </div>
                  </form>
                  <div className="menu-modal-actions"><button type="button" className="admin-primary-button" onClick={state.id ? updated : created}>Salvar adicional</button></div>
                </div>
                <div className="tab-pane fade" id="additional-sheet" role="tabpanel" aria-labelledby="additional-sheet-tab">
                  <div className="mt-2">
                    <DataSheet id={state?.id} keyValue={'idAdditional'} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
